import StablishmentEntity from "../../domain/entities/StablishmentEntity";
import ScheduleDto from "./ScheduleDto";
import UserDto from "./UserDto";

const fromJSON = (json: any): StablishmentEntity => {
    return {
        id: json['id']?.toString() ?? '',
        name: json['name'] ?? '',
        address: json['address'] ?? '',
        latitude: json['latitude'] ? parseFloat(json['latitude']) : undefined,
        longitude: json['longitude'] ? parseFloat(json['longitude']) : undefined,
        phone: json['phoneNumber'] ?? '', // Mapear phoneNumber de la API a phone
        type: json['type'] ?? '',
        email: json['email'] ?? '',
        managerName: json['managerName'] ?? undefined,
        supervisor: json['supervisor'] ? UserDto.fromJSON(json['supervisor']) : undefined,
        schedules: json['schedules'] ? ScheduleDto.fromJSONArray(json['schedules']) : [],
    }
}

const toJson = (stablishment: StablishmentEntity): any => {
    return {
        id: stablishment.id,
        name: stablishment.name,
        address: stablishment.address,
        latitude: stablishment.latitude,
        longitude: stablishment.longitude,
        phoneNumber: stablishment.phone, // Mapear phone del frontend a phoneNumber de la API
        type: stablishment.type,
        email: stablishment.email,
        managerName: stablishment.managerName,
        supervisor_id: stablishment.supervisor?.id,
        schedules: stablishment.schedules ? ScheduleDto.toJsonArray(stablishment.schedules) : [],
    }
}

const fromJSONArray = (jsonArray: any[]): StablishmentEntity[] => {
    if (!Array.isArray(jsonArray)) {
        return [];
    }
    return jsonArray.map(fromJSON);
}

const toJsonArray = (stablishments: StablishmentEntity[]): any[] => {
    return stablishments.map(toJson);
}

export default {
    fromJSON,
    toJson,
    fromJSONArray,
    toJsonArray,
}